import React from 'react';
import {useMediaQuery} from "react-responsive";
import JobOpportunityTabsMobile from "./JobOpportunityTabsMobile";
import JobOpportunityTabsDesktop from "./JobOpportunityTabsDesktop";

function Container(props) {
    const isMobileAndTable = useMediaQuery({query: "(max-width: 1260px)"});
    const currentStatus = props.currentStatus;
    const statusText = props.statusText;

    const tabs = JSON.parse(props.tabs);
    const buttonText = props.buttonText;

    const scrollToForm = (e) => {
        e.preventDefault();
        const formContainer = document.getElementById('job-opportunity-form-container');

        if (formContainer) {
            const yOffset = -275;
            const y = formContainer.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
        }
    };

    if (isMobileAndTable) {
        return (
            <JobOpportunityTabsMobile
                tabs={tabs}
                buttonText={buttonText}
                currentStatus={currentStatus}
                statusText={statusText}
                scrollToForm={scrollToForm}
            />
        )
    }

    return (
        <JobOpportunityTabsDesktop
            tabs={tabs}
            buttonText={buttonText}
            currentStatus={currentStatus}
            statusText={statusText}
            scrollToForm={scrollToForm}
        />
    );
}

export default Container;